import * as React from 'react';
import cn from 'classnames';

import Money from '../Money';
import { useTheme } from '../theme';
import { ServiceSummaryType } from './types';

export interface Props {
	group: ServiceSummaryType;
}

const ServiceSummary: React.FC<Props> = ({ group, children }) => {
	const { ServiceSummary: css } = useTheme('ServiceSummary');

	if (React.Children.toArray(children).every(children => !children)) {
		return null;
	}

	return (
		<div className={css.wrapper}>
			<div
				className={cn(css.header, {
					[css.disabled]: group.disabled
				})}
			>
				<span className={css.header__number} />
				{group.icon && (
					<>
						<span className={css.header__icon}>{group.icon}</span>{' '}
					</>
				)}
				<span className={css.header__title}>{group.header}</span>
				{group.totalPrice?.amount > 0 && (
					<span className={css.header__price}>
						<Money money={group.totalPrice} />
					</span>
				)}
			</div>

			<div className={css.content}>{children}</div>
		</div>
	);
};
export default ServiceSummary;
